<div class="donut-card">
    <div class="donut-card-header">
        <div>
            <div class="donut-title">Most common flags on Metadata</div>
            <div class="donut-subtitle">Top metadata anomalies found in AI-flagged submissions for the selected year.
            </div>
        </div>
        <div class="donut-filters">
            <label>Date</label>
            <select [(ngModel)]="selectedYear">
                <option *ngFor="let year of years" [value]="year">{{ year }}</option>
            </select>
        </div>
    </div>
    <div class="metadata-table-container">
        <table class="metadata-table">
            <thead>
                <tr>
                    <th>Metadata metric</th>
                    <th>Value</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of tableData">
                    <td>{{ row.metric }}</td>
                    <td>{{ row.value }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>